<template>
  <reanalysis-tabs :model="result" />
</template>

<script>
import ReanalysRequest from "../models/reanalys/reanalysrequest";
import WapiReanalysisMessageViewModel from "../models/viewmodels/WapiReanalysisMessageViewModel";
import ReanalysisTabs from "../components/ReanalysisTabs.vue";

export default {
  name: "ReanalysResultView",
  title: "Реанализ",
  components: {
    ReanalysisTabs
  },
  props: {
    dateStart: String,
    dateEnd: String,
    longitude: String,
    latitude: String,
    userId: String
  },
  data() {
    return {
      result: {}
    };
  },
  async created() {
    const request = new ReanalysRequest();
    request.dateStart = this.dateStart;
    request.dateEnd = this.dateEnd;
    request.userId = this.userId;
    request.latitude = this.latitude;
    request.longitude = this.longitude;

    await this.$store.dispatch("SET_LOADING", true);
    const wapiReanalysisMessage = await this.$store.dispatch(
      "FETCH_REANALYS",
      request
    );
    const wapiReanalysisMessageViewModel = new WapiReanalysisMessageViewModel().map(
      wapiReanalysisMessage
    );
    this.result = wapiReanalysisMessageViewModel;

    await this.$store.dispatch("SET_LOADING", false);
  }
};
</script>